<template>
  <div class="bread_box">
    <a v-show="backName" class="go_back" @click="goBack"><span>{{ backName }}</span></a>
    <a
      v-for="(item, index) in list" :key="item.title" :href="item.url"
      class="bread_item" :class="{ 'active': (lastActive && index === list.length - 1) }">
      <span v-if="index !== 0">&gt;</span><span class="font" :class="{ 'href': item.url }">{{ item.title }}</span>
    </a>
    <p v-if="lastStr" class="bread_item">{{ lastStr }}</p>
  </div>
</template>

<script>
export default {
  name: 'Bread',

  props: {
    list: {
      type: Array,
      default: () => []
    },

    lastStr: {
      type: String,
      default: ''
    },

    lastActive: {
      type: Boolean,
      default: false
    },

    backName: {
      type: String,
      default: ''
    },

    backUrl: {
      type: String,
      default: ''
    }
  },

  methods: {
    goBack () {
      if (this.backUrl) {
        this.$router.push(this.backUrl)
        return
      }
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
.bread_box {
  .go_back { font-size: 14px; font-weight: 400; color: $default_primary_color; cursor: pointer; margin-right: 24px;
    &:hover { color: $default_primary_hover; }

    &::before { content: "<"; padding-right: 5px; }
  }

  .bread_item { display: inline-block; font-size: 14px; font-weight: 400; color: #666; text-decoration: none; }
  .active {
    .font { color: $default_primary_color; }
  }
  .href { cursor: pointer;
    &:hover { color: $default_primary_hover; }
  }
}
</style>
